// Home page
export const IS_NOT_SPONSOR = "is_not_sponsor";
export const SL_IS_STARTED = "sl_is_started";
export const SL_IS_STARTED_AND_ON_FINAL_STEPS = "sl_is_started_and_on_final_steps";
export const NEED_TO_COMPLETE_ACCOUNT_SETUP = "need_to_complete_your_account_setup";
export const COMPLIANCE_SUBSCRIPTION_EXPIRED = "compliance_subscription_expired";
export const TRIAL_IS_ENDING_SOON = "trial_is_ending_soon";
export const UPGRADE_TO_PREMIUM = "upgrade_to_premium";
export const HOME_OFFICE_AUDITS = "home_office_audits";
export const SL_GRANTED = "sl_granted";
export const ONGOING_RESPONSIBILITIES = "ongoing_responsibilities";

// Employer visa cases
export const SL_ONBOARDING = "onboarding";
export const NO_SL = "no_sl";
export const SL = "sl";
export const SL_IN_PROGRESS = "sl_in_progress";
export const SL_ON_REVIEW = "sl_on_review";

// Employer employee
export const EMPLOYEE_LESS_THAN_4_MONTHS = "employee_less_than_4_months";
export const EMPLOYEE_EXPIRED = "employee_expired";
export const EMPLOYEE_EXPIRED_LESS_THAN_4_MONTHS = "employee_expired_less_than_4_months";
